<template>
	<campaigns-rule-summary-item
		v-if="group.rules && group.rules[0]"
		:key="`rule-${index}-0`"
		:index="0"
		:group-index="index"
		:item="group.rules[0]"
		v-on="$listeners"
	>
		<template #groupPrefix>{{ 0 === index ? 'If' : 'And' }}</template>

		<template #after>
			<campaigns-rule-summary-item
				v-for="(rule, ruleIndex) in rest(group.rules)"
				:key="`rule-${index}-${ruleIndex + 1}`"
				:index="ruleIndex + 1"
				:group-index="index"
				:item="rule"
				v-on="$listeners"
			/>
		</template>
	</campaigns-rule-summary-item>
</template>

<script lang="js">

/**
 * Campaign Rules Summary Group
 * @displayName Campaign Rules Summary Group
 * @since 2.0.0
 */
export default  {
	props : {
		/**
		 * The group items array.
		 */
		group : {
			type: Object,
			required: true,
		},
		/**
		 * Group Loop index
		 */
		index : {
			type: Number,
			default: 0,
		},
	},
	methods : {
		rest (rules) {
			if (1 < rules.length) {
				// eslint-disable-next-line no-unused-vars
				let [ first, ...rest ] = rules
				return rest
			}

			return []
		},
	},
};
</script>
